import { deprecatedBackgroundColors } from '../types/swan-style.types.js';
import { responsiveModifierSet, isValidStyleProperty, isResponsiveModifier, getKey, stylePropertyValueAliases } from './swan-style.utils.js';
import { iterToSet } from './transform.utils.js';

function getClassName(key, value, modifier = 'xs') {
    if (value === undefined || value === null) {
        return null;
    }
    const effectiveKey = getKey(key);
    if (!effectiveKey) return null;
    const prefix = `swan-${effectiveKey}`;
    const suffix = modifier === 'xs' ? '' : `-${modifier}`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let finalValue = value;
    const aliasObj = stylePropertyValueAliases[key];
    if (aliasObj && (typeof value === 'string' || typeof value === 'number') && value in aliasObj && aliasObj[value] !== undefined) {
        finalValue = aliasObj[value];
    }
    switch(typeof finalValue){
        case 'boolean':
            return finalValue ? prefix + suffix : null;
        default:
            return prefix + `-${finalValue}` + suffix;
    }
}
const warned = {};
function updateClassNameSet(key, value, modifier, classNamesSet) {
    if (process.env.NODE_ENV !== 'production') {
        if (key === 'backgroundColor' || key === 'bgc') {
            const bgc = typeof value === 'object' ? value[modifier] : value;
            if (bgc && deprecatedBackgroundColors.has(bgc) && !warned[bgc.toString()]) {
                console.warn(`Deprecated \`${key}\` prop value: ${bgc}. Replace with an alternative, or use MARKETING_COLORS object for CMS integration.`);
                warned[bgc.toString()] = true;
            }
        }
    }
    const cname = getClassName(key, value, modifier);
    if (cname) {
        classNamesSet.add(cname);
    }
    return classNamesSet;
}
function processResponsiveStyleProps(props, defaultResponsiveModifier, classNameSet = new Set()) {
    Object.keys(props).forEach((propKey)=>{
        if (!isValidStyleProperty(propKey)) {
            return null // exit iteration
            ;
        }
        if (typeof props[propKey] === 'object') {
            // Key must be a modifier
            const responsiveValue = props[propKey];
            // eg: {xs: 1, md: 2}
            Object.keys(responsiveValue).forEach((modifier)=>{
                if (isResponsiveModifier(modifier)) {
                    updateClassNameSet(propKey, responsiveValue[modifier], modifier, classNameSet);
                }
            });
        } else {
            updateClassNameSet(propKey, props[propKey], defaultResponsiveModifier, classNameSet);
        }
    });
    return classNameSet;
}
function processStyleProps(props, defaultClassNameSet) {
    let classNameSet = iterToSet(defaultClassNameSet);
    if (props.swanStyle) {
        const swanStyle = props.swanStyle;
        responsiveModifierSet.forEach((modifier)=>{
            const modifierValue = swanStyle[modifier];
            if (modifierValue) {
                classNameSet = processResponsiveStyleProps(modifierValue, modifier, classNameSet);
            }
        });
        // This only process top level ResponsiveProps, inside Swan Style
        classNameSet = processResponsiveStyleProps(props.swanStyle, 'xs', classNameSet);
    }
    // This only process top level ResponsiveProps
    processResponsiveStyleProps(props, 'xs', classNameSet);
    return classNameSet;
}

export { processStyleProps };
